import React from 'react';
import { Link } from 'react-router-dom';
import './EventsHero.css';

// Import all your event photos
import photo1 from '../../assets/images/event-photo-1.jpg';
import photo2 from '../../assets/images/event-photo-2.jpg';
import photo3 from '../../assets/images/event-photo-3.jpg';
import photo4 from '../../assets/images/event-photo-4.jpg';
import photo5 from '../../assets/images/event-photo-5.jpg';
import photo6 from '../../assets/images/event-photo-6.jpg';
import photo7 from '../../assets/images/event-photo-7.jpg';
import photo8 from '../../assets/images/event-photo-8.jpg';
import photo9 from '../../assets/images/event-photo-9.jpg';
import photo10 from '../../assets/images/event-photo-10.jpg';
import photo11 from '../../assets/images/event-photo-11.jpg';
import photo12 from '../../assets/images/event-photo-12.jpg';
import photo13 from '../../assets/images/event-photo-13.jpg';
import photo14 from '../../assets/images/event-photo-14.jpg';
import photo15 from '../../assets/images/event-photo-15.jpg';

// ... import all 10-15 photos

// Create an array of the imported photos
const collageImages = [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8, photo9, photo10, photo11, photo12, photo13, photo14, photo15];

const EventsHero = () => {
  return (
    <section className="events-hero-section">
      <div className="collage-background">
        {collageImages.map((img, index) => (
          <div className="collage-item" key={index} style={{ backgroundImage: `url(${img})` }}></div>
        ))}
      </div>
      <div className="events-hero-overlay"></div>
      
      <header className="events-header">
        <Link to="/" className="events-logo">CRISHI</Link>
        <nav className="events-nav">
          <Link to="/">HOME</Link>
          <Link to="/events">EVENTS</Link>
          <Link to="/about">ABOUT US</Link>
          <Link to="/partners">PARTNER EVENTS</Link>
          <Link to="/past-events">PAST EVENTS</Link>
          <Link to="/webinar">WEBINAR</Link>
          <Link to="/contact">CONTACT</Link>
        </nav>
      </header>

      <div className="events-hero-content">
        <h1>CONNECT | LEARN | GROW</h1>
        <p>A global community of thought leaders and businesses.</p>
      </div>
    </section>
  );
};

export default EventsHero;